import $window from './window';

export default async function triggerSurvey(surveyTriggered) {
  if (surveyTriggered.current) return;
  surveyTriggered.current = true;
  try {
    $window?.QSI?.API?.unload();
    await new Promise((resolve, reject) => $window?.QSI?.API?.load().promise().then(resolve).fail(reject));
    $window?.QSI?.API?.run();
  } catch (error) {
    console.error(error);
  }
}